module.exports = ":host {\n  width: 100%;\n  padding-top: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/dashboard/upcoming-payments-block/upcoming-payments-block.scss
// module id = ./web/modern/components/dashboard/upcoming-payments-block/upcoming-payments-block.scss
// module chunks = 0